import script from "./ProcessedWork.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessedWork.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessedWork.vue?vue&type=style&index=0&id=ea59dece&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.4.21_typescript@5.9.3__webpack@5.105.4_@swc+core@1.15.8_esbuild@0.27.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea59dece"]])

export default __exports__